var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Mygraph'),_c('router-view'),_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.is_loading,"can-cancel":true},on:{"update:active":function($event){_vm.is_loading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }